import { render, staticRenderFns } from "./AcceptNewLessonTime.vue?vue&type=template&id=6700e985&"
import script from "./AcceptNewLessonTime.vue?vue&type=script&lang=js&"
export * from "./AcceptNewLessonTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports